+(function ($) {

    "use strict";

    //options
    var stickPoint = 40;

    //selectors & classes
    var $nav          = $(".simple-fixed");
    var $companyTitle = $("#main-nav .company-title-small");
    var sticky        = "sticky";

    //invokes on scroll and adds class to simple-nav depending on
    //where the sticking point (stickPoint) is
    $(window).scroll(function () {

        var scroll = $(this).scrollTop();

        if (scroll > stickPoint) {
            $nav.addClass(sticky);
            $companyTitle.css("visibility", "visible");
            $companyTitle.css("opacity", "1");
        } else {
            $companyTitle.css("visibility", "hidden");
            $companyTitle.css("opacity", "0");
            $nav.removeClass(sticky);
        }

    });

})(jQuery);
